import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { SubscriptionList } from '@vendasta/rx-utils';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { Observable } from 'rxjs';
import { delay, distinctUntilChanged, take, tap } from 'rxjs/operators';
import { Market } from '../../../../core/markets/market';
import {
  FacebookFormConfiguration,
  FacebookLeadAdsFormAutomationConfigurationService,
} from '../../fb-forms-automation-configuration.service';
import { MarketDropdownService } from './market-dropdown.service';

@Component({
  templateUrl: 'market-dropdown.component.html',
  styleUrls: [],
  standalone: false,
})
export class MarketDropDownCellComponent implements CustomCellComponent<FacebookFormConfiguration>, OnInit, OnDestroy {
  @Input() columnDefinition: ColumnDefinition;
  @Input() element: FacebookFormConfiguration;

  partnerHasOnlyOneMarket$: Observable<boolean> = this.marketDropdownService.partnerHasOnlyOneMarket$;

  theOnlyMarketPartnerHas$: Observable<Market> = this.marketDropdownService.theOnlyMarketPartnerHas$.pipe(
    delay(0),
    take(1),
  );

  marketOptionsForSelectInput$: Observable<SelectInputOptionInterface[]> =
    this.marketDropdownService.marketOptionsForSelectInput$.pipe(
      tap((options) => {
        const optionToSelect = options.find((option) => option.value === this.element.market) || options[0];
        this.dropDownFormControl.setValue(optionToSelect.value);
      }),
    );

  subscriptionList = SubscriptionList.new();
  dropDownFormControl = new UntypedFormControl();

  constructor(
    @Inject('SAVE_ON_CHANGES') private readonly saveOnChanges: boolean,
    private readonly dataService: FacebookLeadAdsFormAutomationConfigurationService,
    private readonly marketDropdownService: MarketDropdownService,
  ) {}

  ngOnInit(): void {
    this.dropDownFormControl.valueChanges
      .pipe(distinctUntilChanged(), delay(0))
      .subscribe((marketID) => this.changeMarket(marketID));

    this.theOnlyMarketPartnerHas$.subscribe((theOnlyMarket) => {
      this.changeMarket(theOnlyMarket.market_id);
    });
  }

  ngOnDestroy(): void {
    this.subscriptionList.destroy();
  }

  private changeMarket(marketId: string): void {
    this.dataService.updateMarketOnForm(this.element.formID, marketId, this.saveOnChanges);
  }
}
